<template lang="pug">
  .b-base-tooltip
    Icon._icon(:name="icon")
    .__txt {{ text }}
</template>

<script>
export default {
  name: 'BaseTooltip', // todo rename to TooltipIcon & use TooltipDropdown
  props: {
    icon: {
      type: String,
      default: 'question-circle',
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.base-tooltip {
  position: relative;

  &__icon {
    display: block;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  &:hover &__txt {
    opacity: 1;
    visibility: visible;
  }

  &__txt {
    position: absolute;
    z-index: 50;
    top: auto;
    bottom: 40px;
    left: calc(100% - 12px);
    min-width: 200px;
    max-width: 50vw;
    padding: 20px;
    opacity: 0;
    visibility: hidden;
    transform: translateX(-50%);
    background-color: var(--color-white);
    color: var(--color-middle-gray);
    border-radius: 6px;
    box-shadow: 0 2px 30px rgba(0, 0, 0, 0.12);
    font-size: 14px;
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
    filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.08)), drop-shadow(0 15px 30px rgba(0, 0, 0, 0.12));

    &:before {
      content: "";
      display: inline-block;
      position: absolute;
      top: auto;
      bottom: -16px;
      left: 50%;
      width: 32px;
      height: 16px;
      transform: translateX(-50%) rotate(180deg);
      background-image: url(../assets/img/svg/triangle.svg);
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
}

</style>
